import { FontRole, TextStyle } from 'types'

export type FontPairingStyle<R = FontRole> = {
  font_role: R
  style: TextStyle['style'] & {
    line_height?: number
    letter_spacing?: number
    font_family: string
    font_weight: number
  }
}

export type FontPairing = [FontPairingStyle<FontRole.Title>, FontPairingStyle<FontRole.Body>]

export const FONT_PAIRINGS: Array<FontPairing> = [
  [
    {
      font_role: FontRole.Title,
      style: {
        font_family: 'Raleway',
        font_weight: 900,
        italic: false,
        line_height: 1,
        letter_spacing: -40,
      },
    },
    {
      font_role: FontRole.Body,
      style: {
        font_family: 'Raleway',
        font_weight: 600,
        italic: false,
        line_height: 1.2,
        letter_spacing: -10,
      },
    },
  ],

  [
    {
      font_role: FontRole.Title,
      style: {
        font_family: 'Playfair',
        font_weight: 800,
        italic: false,
        line_height: 0.85,
        letter_spacing: -40,
      },
    },
    {
      font_role: FontRole.Body,
      style: {
        font_family: 'Playfair',
        font_weight: 600,
        italic: false,
        line_height: 1.2,
        letter_spacing: -60,
      },
    },
  ],

  [
    {
      font_role: FontRole.Title,
      style: {
        font_family: 'Fjalla One',
        font_weight: 400,
        italic: false,
        line_height: 1,
        letter_spacing: -50,
      },
    },
    {
      font_role: FontRole.Body,
      style: {
        font_family: 'Heebo',
        font_weight: 500,
        italic: false,
        line_height: 1.2,
        letter_spacing: -40,
      },
    },
  ],

  [
    {
      font_role: FontRole.Title,
      style: {
        font_family: 'Bebas Neue',
        font_weight: 400,
        italic: false,
        line_height: 0.9,
        letter_spacing: -30,
      },
    },
    {
      font_role: FontRole.Body,
      style: {
        font_family: 'Heebo',
        font_weight: 500,
        italic: false,
        line_height: 1.2,
        letter_spacing: -40,
      },
    },
  ],

  [
    {
      font_role: FontRole.Title,
      style: {
        font_family: 'Montserrat',
        font_weight: 800,
        italic: false,
        line_height: 1,
        letter_spacing: -50,
      },
    },
    {
      font_role: FontRole.Body,
      style: {
        font_family: 'Montserrat',
        font_weight: 500,
        italic: false,
        line_height: 1.2,
        letter_spacing: -10,
      },
    },
  ],

  [
    {
      font_role: FontRole.Title,
      style: {
        font_family: 'Lora',
        font_weight: 700,
        italic: false,
        line_height: 0.96,
        letter_spacing: -50,
      },
    },
    {
      font_role: FontRole.Body,
      style: {
        font_family: 'Lora',
        font_weight: 500,
        italic: false,
        line_height: 1.2,
        letter_spacing: -20,
      },
    },
  ],

  [
    {
      font_role: FontRole.Title,
      style: {
        font_family: 'Roboto',
        font_weight: 900,
        italic: false,
        line_height: 0.92,
        letter_spacing: -40,
      },
    },
    {
      font_role: FontRole.Body,
      style: {
        font_family: 'Roboto',
        font_weight: 500,
        italic: false,
        line_height: 1.2,
        letter_spacing: -20,
      },
    },
  ],

  [
    {
      font_role: FontRole.Title,
      style: {
        font_family: 'Heebo',
        font_weight: 900,
        italic: false,
        line_height: 0.96,
        letter_spacing: -40,
      },
    },
    {
      font_role: FontRole.Body,
      style: {
        font_family: 'Heebo',
        font_weight: 500,
        italic: false,
        line_height: 1.2,
        letter_spacing: -20,
      },
    },
  ],
  [
    {
      font_role: FontRole.Title,
      style: {
        font_family: 'Oswald',
        font_weight: 700,
        italic: false,
        line_height: 0.97,
        letter_spacing: -50,
      },
    },
    {
      font_role: FontRole.Body,
      style: {
        font_family: 'Roboto',
        font_weight: 500,
        italic: false,
        line_height: 1.2,
        letter_spacing: -20,
      },
    },
  ],

  [
    {
      font_role: FontRole.Title,
      style: {
        font_family: 'Quattrocento',
        font_weight: 700,
        italic: false,
        line_height: 0.97,
        letter_spacing: -40,
      },
    },
    {
      font_role: FontRole.Body,
      style: {
        font_family: 'Lora',
        font_weight: 500,
        italic: false,
        line_height: 1.2,
        letter_spacing: -20,
      },
    },
  ],
  [
    {
      font_role: FontRole.Title,
      style: {
        font_family: 'Spectral',
        font_weight: 800,
        italic: false,
        line_height: 0.97,
        letter_spacing: -50,
      },
    },
    {
      font_role: FontRole.Body,
      style: {
        font_family: 'Lora',
        font_weight: 500,
        italic: false,
        line_height: 1.2,
        letter_spacing: -20,
      },
    },
  ],
  [
    {
      font_role: FontRole.Title,
      style: {
        font_family: 'Nunito',
        font_weight: 800,
        italic: false,
        line_height: 0.95,
        letter_spacing: -30,
      },
    },
    {
      font_role: FontRole.Body,
      style: {
        font_family: 'Nunito',
        font_weight: 700,
        italic: false,
        line_height: 1.2,
        letter_spacing: -20,
      },
    },
  ],

  [
    {
      font_role: FontRole.Title,
      style: {
        font_family: 'Quicksand',
        font_weight: 700,
        italic: false,
        line_height: 0.95,
        letter_spacing: -40,
      },
    },
    {
      font_role: FontRole.Body,
      style: {
        font_family: 'Nunito',
        font_weight: 700,
        italic: false,
        line_height: 1.2,
        letter_spacing: -20,
      },
    },
  ],

  [
    {
      font_role: FontRole.Title,
      style: {
        font_family: 'Epilogue',
        font_weight: 800,
        italic: false,
        line_height: 0.95,
        letter_spacing: -50,
      },
    },
    {
      font_role: FontRole.Body,
      style: {
        font_family: 'Epilogue',
        font_weight: 500,
        italic: false,
        line_height: 1.2,
        letter_spacing: -20,
      },
    },
  ],
  [
    {
      font_role: FontRole.Title,
      style: {
        font_family: 'Libre Baskerville',
        font_weight: 700,
        italic: false,
        line_height: 0.95,
        letter_spacing: -70,
      },
    },
    {
      font_role: FontRole.Body,
      style: {
        font_family: 'Libre Baskerville',
        font_weight: 400,
        italic: false,
        line_height: 1.2,
        letter_spacing: -20,
      },
    },
  ],

  [
    {
      font_role: FontRole.Title,
      style: {
        font_family: 'Karla',
        font_weight: 800,
        italic: false,
        line_height: 0.95,
        letter_spacing: -80,
      },
    },
    {
      font_role: FontRole.Body,
      style: {
        font_family: 'Karla',
        font_weight: 500,
        italic: false,
        line_height: 1.2,
        letter_spacing: -60,
      },
    },
  ],

  [
    {
      font_role: FontRole.Title,
      style: {
        font_family: 'Nunito Sans',
        font_weight: 900,
        italic: false,
        line_height: 0.9,
        letter_spacing: -30,
      },
    },
    {
      font_role: FontRole.Body,
      style: {
        font_family: 'Nunito Sans',
        font_weight: 600,
        italic: false,
        line_height: 1.2,
        letter_spacing: -30,
      },
    },
  ],
  [
    {
      font_role: FontRole.Title,
      style: {
        font_family: 'Ubuntu Sans',
        font_weight: 800,
        italic: false,
        line_height: 0.9,
        letter_spacing: -30,
      },
    },
    {
      font_role: FontRole.Body,
      style: {
        font_family: 'Ubuntu Sans',
        font_weight: 500,
        italic: false,
        line_height: 1.2,
        letter_spacing: -30,
      },
    },
  ],
  [
    {
      font_role: FontRole.Title,
      style: {
        font_family: 'Lustria',
        font_weight: 400,
        italic: false,
        line_height: 0.9,
        letter_spacing: -60,
      },
    },
    {
      font_role: FontRole.Body,
      style: {
        font_family: 'Lora',
        font_weight: 500,
        italic: false,
        line_height: 1.2,
        letter_spacing: -30,
      },
    },
  ],
  [
    {
      font_role: FontRole.Title,
      style: {
        font_family: 'Syne',
        font_weight: 700,
        italic: false,
        line_height: 0.92,
        letter_spacing: -30,
      },
    },
    {
      font_role: FontRole.Body,
      style: {
        font_family: 'Lora',
        font_weight: 400,
        italic: false,
        line_height: 1.2,
        letter_spacing: -10,
      },
    },
  ],
  [
    {
      font_role: FontRole.Title,
      style: {
        font_family: 'Merriweather',
        font_weight: 900,
        italic: false,
        line_height: 1,
        letter_spacing: -30,
      },
    },
    {
      font_role: FontRole.Body,
      style: {
        font_family: 'Merriweather',
        font_weight: 400,
        italic: false,
        line_height: 1.35,
        letter_spacing: -10,
      },
    },
  ],
  [
    {
      font_role: FontRole.Title,
      style: {
        font_family: 'Ultra',
        font_weight: 400,
        italic: false,
        line_height: 1,
        letter_spacing: -30,
      },
    },
    {
      font_role: FontRole.Body,
      style: {
        font_family: 'Merriweather',
        font_weight: 400,
        italic: false,
        line_height: 1.35,
        letter_spacing: -10,
      },
    },
  ],
  [
    {
      font_role: FontRole.Title,
      style: {
        font_family: 'Barlow',
        font_weight: 900,
        italic: false,
        line_height: 0.9,
        letter_spacing: -10,
      },
    },
    {
      font_role: FontRole.Body,
      style: {
        font_family: 'Barlow',
        font_weight: 500,
        italic: false,
        line_height: 1.35,
        letter_spacing: -50,
      },
    },
  ],
  [
    {
      font_role: FontRole.Title,
      style: {
        font_family: 'Roboto Condensed',
        font_weight: 900,
        italic: false,
        line_height: 0.9,
        letter_spacing: -40,
      },
    },
    {
      font_role: FontRole.Body,
      style: {
        font_family: 'Roboto Condensed',
        font_weight: 400,
        italic: false,
        line_height: 1.35,
        letter_spacing: -20,
      },
    },
  ],
  [
    {
      font_role: FontRole.Title,
      style: {
        font_family: 'Work Sans',
        font_weight: 900,
        italic: false,
        line_height: 0.9,
        letter_spacing: -40,
      },
    },
    {
      font_role: FontRole.Body,
      style: {
        font_family: 'Work Sans',
        font_weight: 500,
        italic: false,
        line_height: 1.35,
        letter_spacing: -40,
      },
    },
  ],
  [
    {
      font_role: FontRole.Title,
      style: {
        font_family: 'Source Sans 3',
        font_weight: 900,
        italic: false,
        line_height: 0.9,
        letter_spacing: -40,
      },
    },
    {
      font_role: FontRole.Body,
      style: {
        font_family: 'Source Sans 3',
        font_weight: 500,
        italic: false,
        line_height: 1.35,
        letter_spacing: -40,
      },
    },
  ],
  [
    {
      font_role: FontRole.Title,
      style: {
        font_family: 'Pacifico',
        font_weight: 400,
        italic: false,
        line_height: 1.1,
        letter_spacing: -10,
      },
    },
    {
      font_role: FontRole.Body,
      style: {
        font_family: 'Inter',
        font_weight: 400,
        italic: false,
        line_height: 1.35,
        letter_spacing: -40,
      },
    },
  ],
  [
    {
      font_role: FontRole.Title,
      style: {
        font_family: 'Cormorant Garamond',
        font_weight: 700,
        italic: false,
        line_height: 0.9,
        letter_spacing: -30,
      },
    },
    {
      font_role: FontRole.Body,
      style: {
        font_family: 'Source Serif 4',
        font_weight: 400,
        italic: false,
        line_height: 1.35,
        letter_spacing: -40,
      },
    },
  ],
  [
    {
      font_role: FontRole.Title,
      style: {
        font_family: 'Source Serif 4',
        font_weight: 700,
        italic: false,
        line_height: 0.93,
        letter_spacing: -40,
      },
    },
    {
      font_role: FontRole.Body,
      style: {
        font_family: 'Merriweather',
        font_weight: 400,
        italic: false,
        line_height: 1.2,
        letter_spacing: -20,
      },
    },
  ],
  [
    {
      font_role: FontRole.Title,
      style: {
        font_family: 'Hepta Slab',
        font_weight: 800,
        italic: false,
        line_height: 0.97,
        letter_spacing: -20,
      },
    },
    {
      font_role: FontRole.Body,
      style: {
        font_family: 'Hepta Slab',
        font_weight: 500,
        italic: false,
        line_height: 1.35,
        letter_spacing: -30,
      },
    },
  ],
  [
    {
      font_role: FontRole.Title,
      style: {
        font_family: 'Libre Caslon Text',
        font_weight: 500,
        italic: false,
        line_height: 0.97,
        letter_spacing: -50,
      },
    },
    {
      font_role: FontRole.Body,
      style: {
        font_family: 'Libre Caslon Text',
        font_weight: 500,
        italic: false,
        line_height: 1.27,
        letter_spacing: -50,
      },
    },
  ],
  [
    {
      font_role: FontRole.Title,
      style: {
        font_family: 'Open Sans',
        font_weight: 700,
        italic: false,
        line_height: 1,
        letter_spacing: -50,
      },
    },
    {
      font_role: FontRole.Body,
      style: {
        font_family: 'Open Sans',
        font_weight: 400,
        italic: false,
        line_height: 1.4,
        letter_spacing: -10,
      },
    },
  ],
  [
    {
      font_role: FontRole.Title,
      style: {
        font_family: 'Poppins',
        font_weight: 700,
        italic: false,
        line_height: 1.05,
        letter_spacing: -50,
      },
    },
    {
      font_role: FontRole.Body,
      style: {
        font_family: 'Poppins',
        font_weight: 400,
        italic: false,
        line_height: 1.4,
        letter_spacing: -20,
      },
    },
  ],
  [
    {
      font_role: FontRole.Title,
      style: {
        font_family: 'Crimson Text',
        font_weight: 400,
        italic: false,
        line_height: 0.9,
        letter_spacing: -50,
      },
    },
    {
      font_role: FontRole.Body,
      style: {
        font_family: 'Crimson Text',
        font_weight: 400,
        italic: false,
        line_height: 1.4,
        letter_spacing: -20,
      },
    },
  ],
  [
    {
      font_role: FontRole.Title,
      style: {
        font_family: 'Lato',
        font_weight: 700,
        italic: false,
        line_height: 0.9,
        letter_spacing: -30,
      },
    },
    {
      font_role: FontRole.Body,
      style: {
        font_family: 'Lato',
        font_weight: 400,
        italic: false,
        line_height: 1.4,
        letter_spacing: -20,
      },
    },
  ],
  [
    {
      font_role: FontRole.Title,
      style: {
        font_family: 'Cabin',
        font_weight: 700,
        italic: false,
        line_height: 0.9,
        letter_spacing: -60,
      },
    },
    {
      font_role: FontRole.Body,
      style: {
        font_family: 'Cabin',
        font_weight: 400,
        italic: false,
        line_height: 1.4,
        letter_spacing: -10,
      },
    },
  ],
  [
    {
      font_role: FontRole.Title,
      style: {
        font_family: 'Manrope',
        font_weight: 800,
        italic: false,
        line_height: 1,
        letter_spacing: -60,
      },
    },
    {
      font_role: FontRole.Body,
      style: {
        font_family: 'Manrope',
        font_weight: 400,
        italic: false,
        line_height: 1.4,
        letter_spacing: 0,
      },
    },
  ],
  [
    {
      font_role: FontRole.Title,
      style: {
        font_family: 'Josefin Sans',
        font_weight: 700,
        italic: false,
        line_height: 1,
        letter_spacing: -60,
      },
    },
    {
      font_role: FontRole.Body,
      style: {
        font_family: 'Roboto',
        font_weight: 400,
        italic: false,
        line_height: 1.4,
        letter_spacing: -20,
      },
    },
  ],
  [
    {
      font_role: FontRole.Title,
      style: {
        font_family: 'PT Sans',
        font_weight: 700,
        italic: false,
        line_height: 1,
        letter_spacing: -30,
      },
    },
    {
      font_role: FontRole.Body,
      style: {
        font_family: 'PT Sans',
        font_weight: 400,
        italic: false,
        line_height: 1.4,
        letter_spacing: -20,
      },
    },
  ],
  [
    {
      font_role: FontRole.Title,
      style: {
        font_family: 'Hind',
        font_weight: 700,
        italic: false,
        line_height: 0.96,
        letter_spacing: -40,
      },
    },
    {
      font_role: FontRole.Body,
      style: {
        font_family: 'Hind',
        font_weight: 400,
        italic: false,
        line_height: 1.4,
        letter_spacing: -10,
      },
    },
  ],
  [
    {
      font_role: FontRole.Title,
      style: {
        font_family: 'Halant',
        font_weight: 700,
        italic: false,
        line_height: 0.96,
        letter_spacing: -30,
      },
    },
    {
      font_role: FontRole.Body,
      style: {
        font_family: 'Halant',
        font_weight: 400,
        italic: false,
        line_height: 1.4,
        letter_spacing: -10,
      },
    },
  ],
  [
    {
      font_role: FontRole.Title,
      style: {
        font_family: 'Slint Ultra Expanded',
        font_weight: 400,
        italic: false,
        line_height: 1,
        letter_spacing: -50,
      },
    },
    {
      font_role: FontRole.Body,
      style: {
        font_family: 'Lora',
        font_weight: 400,
        italic: false,
        line_height: 1.2,
        letter_spacing: -20,
      },
    },
  ],
  [
    {
      font_role: FontRole.Title,
      style: {
        font_family: 'Nixie One',
        font_weight: 400,
        italic: false,
        line_height: 1,
        letter_spacing: -50,
      },
    },
    {
      font_role: FontRole.Body,
      style: {
        font_family: 'Lora',
        font_weight: 400,
        italic: false,
        line_height: 1.2,
        letter_spacing: -20,
      },
    },
  ],
  [
    {
      font_role: FontRole.Title,
      style: {
        font_family: 'Teko',
        font_weight: 600,
        italic: false,
        line_height: 0.8,
        letter_spacing: -30,
      },
    },
    {
      font_role: FontRole.Body,
      style: {
        font_family: 'Roboto',
        font_weight: 400,
        italic: false,
        line_height: 1.4,
        letter_spacing: -20,
      },
    },
  ],
  [
    {
      font_role: FontRole.Title,
      style: {
        font_family: 'Albert Sans',
        font_weight: 900,
        italic: false,
        line_height: 0.86,
        letter_spacing: -40,
      },
    },
    {
      font_role: FontRole.Body,
      style: {
        font_family: 'Albert Sans',
        font_weight: 400,
        italic: false,
        line_height: 1.4,
        letter_spacing: -10,
      },
    },
  ],
  [
    {
      font_role: FontRole.Title,
      style: {
        font_family: 'DM Sans',
        font_weight: 900,
        italic: false,
        line_height: 0.86,
        letter_spacing: -20,
      },
    },
    {
      font_role: FontRole.Body,
      style: {
        font_family: 'DM Sans',
        font_weight: 400,
        italic: false,
        line_height: 1.4,
        letter_spacing: -10,
      },
    },
  ],
  [
    {
      font_role: FontRole.Title,
      style: {
        font_family: 'Inter',
        font_weight: 700,
        italic: false,
        line_height: 0.9,
        letter_spacing: -30,
      },
    },
    {
      font_role: FontRole.Body,
      style: {
        font_family: 'Inter',
        font_weight: 400,
        italic: false,
        line_height: 1.4,
        letter_spacing: -20,
      },
    },
  ],
  [
    {
      font_role: FontRole.Title,
      style: {
        font_family: 'Aboreto',
        font_weight: 400,
        italic: false,
        line_height: 0.9,
        letter_spacing: -90,
      },
    },
    {
      font_role: FontRole.Body,
      style: {
        font_family: 'Inter',
        font_weight: 400,
        italic: false,
        line_height: 1.4,
        letter_spacing: -20,
      },
    },
  ],
  [
    {
      font_role: FontRole.Title,
      style: {
        font_family: 'Outfit',
        font_weight: 800,
        italic: false,
        line_height: 1,
        letter_spacing: -30,
      },
    },
    {
      font_role: FontRole.Body,
      style: {
        font_family: 'Outfit',
        font_weight: 300,
        italic: false,
        line_height: 1.4,
        letter_spacing: 0,
      },
    },
  ],
  [
    {
      font_role: FontRole.Title,
      style: {
        font_family: 'Lexend',
        font_weight: 700,
        italic: false,
        line_height: 0.96,
        letter_spacing: -60,
      },
    },
    {
      font_role: FontRole.Body,
      style: {
        font_family: 'Lexend',
        font_weight: 300,
        italic: false,
        line_height: 1.4,
        letter_spacing: 0,
      },
    },
  ],
  [
    {
      font_role: FontRole.Title,
      style: {
        font_family: 'Marcellus',
        font_weight: 400,
        italic: false,
        line_height: 0.96,
        letter_spacing: -40,
      },
    },
    {
      font_role: FontRole.Body,
      style: {
        font_family: 'Marcellus',
        font_weight: 400,
        italic: false,
        line_height: 1.4,
        letter_spacing: 0,
      },
    },
  ],
  [
    {
      font_role: FontRole.Title,
      style: {
        font_family: 'Montagu Slab',
        font_weight: 700,
        italic: false,
        line_height: 0.96,
        letter_spacing: -60,
      },
    },
    {
      font_role: FontRole.Body,
      style: {
        font_family: 'Lora',
        font_weight: 400,
        italic: false,
        line_height: 1.4,
        letter_spacing: -20,
      },
    },
  ],
  [
    {
      font_role: FontRole.Title,
      style: {
        font_family: 'Abhaya Libre',
        font_weight: 700,
        italic: false,
        line_height: 0.88,
        letter_spacing: -40,
      },
    },
    {
      font_role: FontRole.Body,
      style: {
        font_family: 'Abhaya Libre',
        font_weight: 400,
        italic: false,
        line_height: 1.2,
        letter_spacing: -20,
      },
    },
  ],
  [
    {
      font_role: FontRole.Title,
      style: {
        font_family: 'League Spartan',
        font_weight: 800,
        italic: false,
        line_height: 1,
        letter_spacing: -50,
      },
    },
    {
      font_role: FontRole.Body,
      style: {
        font_family: 'League Spartan',
        font_weight: 400,
        italic: false,
        line_height: 1.2,
        letter_spacing: -20,
      },
    },
  ],
  [
    {
      font_role: FontRole.Title,
      style: {
        font_family: 'Anton',
        font_weight: 400,
        italic: false,
        line_height: 1.1,
        letter_spacing: -10,
      },
    },
    {
      font_role: FontRole.Body,
      style: {
        font_family: 'Inter',
        font_weight: 400,
        italic: false,
        line_height: 1.4,
        letter_spacing: -20,
      },
    },
  ],
  [
    {
      font_role: FontRole.Title,
      style: {
        font_family: 'Actor',
        font_weight: 400,
        italic: false,
        line_height: 1.05,
        letter_spacing: -60,
      },
    },
    {
      font_role: FontRole.Body,
      style: {
        font_family: 'Actor',
        font_weight: 400,
        italic: false,
        line_height: 1.4,
        letter_spacing: 0,
      },
    },
  ],
  [
    {
      font_role: FontRole.Title,
      style: {
        font_family: 'Cinzel',
        font_weight: 700,
        italic: false,
        line_height: 1.05,
        letter_spacing: -50,
      },
    },
    {
      font_role: FontRole.Body,
      style: {
        font_family: 'Lora',
        font_weight: 400,
        italic: false,
        line_height: 1.4,
        letter_spacing: -20,
      },
    },
  ],
  [
    {
      font_role: FontRole.Title,
      style: {
        font_family: 'Calistoga',
        font_weight: 400,
        italic: false,
        line_height: 1.05,
        letter_spacing: -30,
      },
    },
    {
      font_role: FontRole.Body,
      style: {
        font_family: 'Lora',
        font_weight: 400,
        italic: false,
        line_height: 1.4,
        letter_spacing: -20,
      },
    },
  ],
  [
    {
      font_role: FontRole.Title,
      style: {
        font_family: 'Bricolage Grotesque',
        font_weight: 800,
        italic: false,
        line_height: 0.8,
        letter_spacing: -20,
      },
    },
    {
      font_role: FontRole.Body,
      style: {
        font_family: 'Bricolage Grotesque',
        font_weight: 500,
        italic: false,
        line_height: 1.35,
        letter_spacing: -30,
      },
    },
  ],
  [
    {
      font_role: FontRole.Title,
      style: {
        font_family: 'Inter',
        font_weight: 900,
        italic: false,
        line_height: 0.8,
        letter_spacing: -60,
      },
    },
    {
      font_role: FontRole.Body,
      style: {
        font_family: 'Inter',
        font_weight: 500,
        italic: false,
        line_height: 1.35,
        letter_spacing: -30,
      },
    },
  ],
  [
    {
      font_role: FontRole.Title,
      style: {
        font_family: 'Instrument Serif',
        font_weight: 400,
        italic: false,
        line_height: 0.8,
        letter_spacing: -30,
      },
    },
    {
      font_role: FontRole.Body,
      style: {
        font_family: 'Lora',
        font_weight: 400,
        italic: false,
        line_height: 1.35,
        letter_spacing: -30,
      },
    },
  ],
  [
    {
      font_role: FontRole.Title,
      style: {
        font_family: 'Boldonse',
        font_weight: 400,
        italic: false,
        line_height: 1.4,
        letter_spacing: -50,
      },
    },
    {
      font_role: FontRole.Body,
      style: {
        font_family: 'Manrope',
        font_weight: 500,
        italic: false,
        line_height: 1.35,
        letter_spacing: -10,
      },
    },
  ],
  [
    {
      font_role: FontRole.Title,
      style: {
        font_family: 'Sansita',
        font_weight: 800,
        italic: false,
        line_height: 0.9,
        letter_spacing: -40,
      },
    },
    {
      font_role: FontRole.Body,
      style: {
        font_family: 'Lora',
        font_weight: 500,
        italic: false,
        line_height: 1.35,
        letter_spacing: -30,
      },
    },
  ],
  [
    {
      font_role: FontRole.Title,
      style: {
        font_family: 'Overlock',
        font_weight: 900,
        italic: false,
        line_height: 0.9,
        letter_spacing: -40,
      },
    },
    {
      font_role: FontRole.Body,
      style: {
        font_family: 'Lora',
        font_weight: 500,
        italic: false,
        line_height: 1.35,
        letter_spacing: -30,
      },
    },
  ],
  [
    {
      font_role: FontRole.Title,
      style: {
        font_family: 'Bona Nova',
        font_weight: 700,
        italic: false,
        line_height: 1,
        letter_spacing: -50,
      },
    },
    {
      font_role: FontRole.Body,
      style: {
        font_family: 'Lora',
        font_weight: 500,
        italic: false,
        line_height: 1.35,
        letter_spacing: -30,
      },
    },
  ],
  [
    {
      font_role: FontRole.Title,
      style: {
        font_family: 'Wittgenstein',
        font_weight: 600,
        italic: false,
        line_height: 1,
        letter_spacing: -50,
      },
    },
    {
      font_role: FontRole.Body,
      style: {
        font_family: 'Lora',
        font_weight: 500,
        italic: false,
        line_height: 1.35,
        letter_spacing: -30,
      },
    },
  ],
  [
    {
      font_role: FontRole.Title,
      style: {
        font_family: 'Teachers',
        font_weight: 700,
        italic: false,
        line_height: 0.98,
        letter_spacing: -50,
      },
    },
    {
      font_role: FontRole.Body,
      style: {
        font_family: 'Inter',
        font_weight: 500,
        italic: false,
        line_height: 1.35,
        letter_spacing: -30,
      },
    },
  ],
  [
    {
      font_role: FontRole.Title,
      style: {
        font_family: 'Radio Canada Big',
        font_weight: 700,
        italic: false,
        line_height: 0.91,
        letter_spacing: -50,
      },
    },
    {
      font_role: FontRole.Body,
      style: {
        font_family: 'Radio Canada Big',
        font_weight: 400,
        italic: false,
        line_height: 1.35,
        letter_spacing: -30,
      },
    },
  ],
  [
    {
      font_role: FontRole.Title,
      style: {
        font_family: 'Platypi',
        font_weight: 700,
        italic: false,
        line_height: 0.95,
        letter_spacing: -50,
      },
    },
    {
      font_role: FontRole.Body,
      style: {
        font_family: 'Platypi',
        font_weight: 500,
        italic: false,
        line_height: 1.35,
        letter_spacing: -30,
      },
    },
  ],
  [
    {
      font_role: FontRole.Title,
      style: {
        font_family: 'Afacad',
        font_weight: 700,
        italic: false,
        line_height: 0.87,
        letter_spacing: -50,
      },
    },
    {
      font_role: FontRole.Body,
      style: {
        font_family: 'Afacad',
        font_weight: 400,
        italic: false,
        line_height: 1.14,
        letter_spacing: -30,
      },
    },
  ],
  [
    {
      font_role: FontRole.Title,
      style: {
        font_family: 'AR One Sans',
        font_weight: 700,
        italic: false,
        line_height: 0.87,
        letter_spacing: -50,
      },
    },
    {
      font_role: FontRole.Body,
      style: {
        font_family: 'AR One Sans',
        font_weight: 500,
        italic: false,
        line_height: 1.14,
        letter_spacing: -50,
      },
    },
  ],
  [
    {
      font_role: FontRole.Title,
      style: {
        font_family: 'Onest',
        font_weight: 900,
        italic: false,
        line_height: 0.87,
        letter_spacing: -40,
      },
    },
    {
      font_role: FontRole.Body,
      style: {
        font_family: 'Onest',
        font_weight: 500,
        italic: false,
        line_height: 1.14,
        letter_spacing: -30,
      },
    },
  ],
  [
    {
      font_role: FontRole.Title,
      style: {
        font_family: 'Rethink Sans',
        font_weight: 800,
        italic: false,
        line_height: 0.87,
        letter_spacing: 0,
      },
    },
    {
      font_role: FontRole.Body,
      style: {
        font_family: 'Rethink Sans',
        font_weight: 500,
        italic: false,
        line_height: 1.14,
        letter_spacing: -30,
      },
    },
  ],
  [
    {
      font_role: FontRole.Title,
      style: {
        font_family: 'Geologica',
        font_weight: 800,
        italic: false,
        line_height: 0.92,
        letter_spacing: -50,
      },
    },
    {
      font_role: FontRole.Body,
      style: {
        font_family: 'Geologica',
        font_weight: 400,
        italic: false,
        line_height: 1.14,
        letter_spacing: -30,
      },
    },
  ],
  [
    {
      font_role: FontRole.Title,
      style: {
        font_family: 'Wix Madefor Display',
        font_weight: 800,
        italic: false,
        line_height: 0.92,
        letter_spacing: -50,
      },
    },
    {
      font_role: FontRole.Body,
      style: {
        font_family: 'Wix Madefor Display',
        font_weight: 600,
        italic: false,
        line_height: 1.14,
        letter_spacing: -30,
      },
    },
  ],
  [
    {
      font_role: FontRole.Title,
      style: {
        font_family: 'Instrument Sans',
        font_weight: 700,
        italic: false,
        line_height: 0.92,
        letter_spacing: -30,
      },
    },
    {
      font_role: FontRole.Body,
      style: {
        font_family: 'Instrument Sans',
        font_weight: 500,
        italic: false,
        line_height: 1.14,
        letter_spacing: -30,
      },
    },
  ],
  [
    {
      font_role: FontRole.Title,
      style: {
        font_family: 'Schibsted Grotesk',
        font_weight: 900,
        italic: false,
        line_height: 0.92,
        letter_spacing: -50,
      },
    },
    {
      font_role: FontRole.Body,
      style: {
        font_family: 'Schibsted Grotesk',
        font_weight: 500,
        italic: false,
        line_height: 1.14,
        letter_spacing: -30,
      },
    },
  ],
  [
    {
      font_role: FontRole.Title,
      style: {
        font_family: 'Labrada',
        font_weight: 800,
        italic: false,
        line_height: 0.92,
        letter_spacing: -50,
      },
    },
    {
      font_role: FontRole.Body,
      style: {
        font_family: 'Labrada',
        font_weight: 500,
        italic: false,
        line_height: 1.14,
        letter_spacing: -30,
      },
    },
  ],
  [
    {
      font_role: FontRole.Title,
      style: {
        font_family: 'Sofia Sans Condensed',
        font_weight: 800,
        italic: false,
        line_height: 0.92,
        letter_spacing: -40,
      },
    },
    {
      font_role: FontRole.Body,
      style: {
        font_family: 'Sofia Sans',
        font_weight: 400,
        italic: false,
        line_height: 1.14,
        letter_spacing: -30,
      },
    },
  ],
  [
    {
      font_role: FontRole.Title,
      style: {
        font_family: 'Sofia Sans Extra Condensed',
        font_weight: 900,
        italic: false,
        line_height: 0.84,
        letter_spacing: -30,
      },
    },
    {
      font_role: FontRole.Body,
      style: {
        font_family: 'Sofia Sans',
        font_weight: 400,
        italic: false,
        line_height: 1.14,
        letter_spacing: -30,
      },
    },
  ],

  [
    {
      font_role: FontRole.Title,
      style: {
        font_family: 'IBM Plex Sans Condensed',
        font_weight: 700,
        italic: false,
        line_height: 0.84,
        letter_spacing: -50,
      },
    },
    {
      font_role: FontRole.Body,
      style: {
        font_family: 'IBM Plex Sans Condensed',
        font_weight: 500,
        italic: false,
        line_height: 1.14,
        letter_spacing: -10,
      },
    },
  ],
]
